import { DatePipe } from "@angular/common";
import { Component, inject, OnDestroy, OnInit, signal } from "@angular/core";
import { FormControl, ReactiveFormsModule } from "@angular/forms";
import { ActivatedRoute, Router, RouterModule } from "@angular/router";
import { ButtonModule } from "primeng/button";
import { FieldsetModule } from "primeng/fieldset";
import { FloatLabelModule } from "primeng/floatlabel";
import { IftaLabelModule } from "primeng/iftalabel";
import { InputTextModule } from "primeng/inputtext";
import { MessageModule } from "primeng/message";
import { TableLazyLoadEvent, TableModule } from "primeng/table";
import { TooltipModule } from "primeng/tooltip";
import { ToastService } from "../../../../common/services/toast.service";
import { DialogService } from "primeng/dynamicdialog";
import { debounceTime, distinctUntilChanged, Subject, takeUntil } from "rxjs";
import { GradeBookService } from "../../services/grade-book.service";
import { GetGradeResponseDto } from "../../dtos/get-grade.response.dto";


@Component({
  selector: 'app-view-grade-book',
  standalone: true,
  imports: [
      TableModule,
      FieldsetModule,
      TooltipModule,
      ButtonModule,
      MessageModule,
      RouterModule,
      DatePipe,
      FloatLabelModule,
      ReactiveFormsModule,
      InputTextModule,
      IftaLabelModule,
      ReactiveFormsModule
  ],
  providers: [DialogService,ToastService,GradeBookService],
  templateUrl: './view-grade-book.html',
  styleUrls: ['./view-grade-book.css'],
})
export class ViewGradeBookComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  private isSearchTriggered = false;
  private route = inject(ActivatedRoute);
  private gradeBookService:GradeBookService = inject(GradeBookService);
  private lineItemId:string = "";
  courseCode:string = "";
  loading = signal<boolean>(false);
  noDataFound = signal<boolean>(false);
  gradeBook:Array<GetGradeResponseDto> = new Array<GetGradeResponseDto>()
  selectedLearnerWithGrade!:GetGradeResponseDto
  first: number = 0;
  rows: number = 10;
  totalRecords = signal<number>(0);
  sortField = 'firstName';
  sortOrder = 'ASC';
  searchQuery:FormControl = new FormControl();
  toastService = inject(ToastService);


    ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.complete();    
    }
    ngOnInit(): void {
      this.lineItemId = this.route.snapshot.params['lineItemId'];
      this.courseCode = this.route.snapshot.params['courseCode'];
      this.searchQuery.valueChanges.pipe(
                    debounceTime(300),
                    distinctUntilChanged(),
                    takeUntil(this.destroy$)
                  ).subscribe((value: string) => {
                    if (value && value.length >= 5) {
                      this.isSearchTriggered = true;
                      this.first = 0;
                      this.loadGradebook({
                        skip: 0,
                        limit: this.rows,
                        sortField: this.sortField,
                        sortOrder: this.sortOrder
                      });
                    } else if (!value || value.length === 0) {
                      // Reset to show all results when search is cleared
                      this.isSearchTriggered = true;
                      this.first = 0;
                      this.loadGradebook({
                        skip: 0,
                        limit: this.rows,
                        sortField: this.sortField,
                        sortOrder: this.sortOrder
                      });
                    }
                  });
    }
    

  onLazyLoad(event: TableLazyLoadEvent) {
    // Skip if this was triggered by search resetting first
    if (this.isSearchTriggered) {
      this.isSearchTriggered = false;
      return;
    }
    
    // Update stored values for use by search
    this.sortField = event.sortField as string ?? this.sortField;
    this.sortOrder = event.sortOrder === 1 ? 'ASC' : 'DESC';
    this.rows = event.rows ?? 10;
    
    this.loadGradebook({ 
      skip: event.first ?? 0,
      limit: this.rows,
      sortField: this.sortField,
      sortOrder: this.sortOrder 
    });
  }
  async loadGradebook({skip,limit,sortField,sortOrder}:{skip:number,limit:number,sortField:string,sortOrder:string}){
    try{
      this.loading.set(true);
      const response = await this.gradeBookService.getGrades(this.lineItemId,{skip,limit,sortField,sortOrder,searchQuery:this.searchQuery.value});
      this.gradeBook = response.data
      this.totalRecords.set(response.total);
      this.noDataFound.set(response.total === 0)
    }catch(e){
       this.toastService.show({severity:"error", summary:"Error",detail:"Failed to load gradebook, please contact tech-support."}); 
       console.error(e);
    } finally {
      this.loading.set(false);
    }
  }
}